import Badge from "../../../Components/Badge";
import EditIcon from "../../../Assets/Icons/outline/edit.svg";
import TrashIcon from "../../../Assets/Icons/outline/trash.svg";

const IncentiveTable = ({ data, from, handleShow }) => {
	return (
		<table className="w-full text-left">
			<thead className="border-t border-b border-black">
				<tr>
					<th scope="col" className="px-6 py-1">
						<div className="border-e border-black py-1">No</div>
					</th>
					<th scope="col" className="px-6 py-1">
						<div className="border-e border-black py-1">Project Type</div>
					</th>
					<th scope="col" className="px-6 py-1">
						<div className="border-e border-black py-1">Bonus</div>
					</th>
					<th scope="col" className="px-6 py-1">
						<div className="py-1">Action</div>
					</th>
				</tr>
			</thead>
			<tbody className="font-light">
				{data?.map((item, index) => (
					<tr key={index}>
						<td className="px-6 py-4 w-[100px]">{from++}</td>
						<td className="px-6 py-4">
							<div className="font-semibold">{item?.name}</div>
						</td>
						<td className="px-6 py-4">
							<div className="font-semibold">
								{item?.bonus
									? new Intl.NumberFormat("id-ID", {
											style: "currency",
											currency: "IDR",
											minimumFractionDigits: 0,
									  }).format(item.bonus)
									: "Rp 0"}
							</div>
						</td>
						<td className="px-6 py-4 w-[150px]">
							<div className="flex items-center">
								<div className="me-5">
									<button className="button" onClick={() => handleShow(null, "update", item)}>
										<img src={EditIcon} alt="" className="w-[25px] h-[25px]" />
									</button>
								</div>
								<div className="me-5">
									<button className="button" onClick={() => handleShow(null, "delete", item)}>
										<img src={TrashIcon} alt="" className="w-[25px] h-[25px]" />
									</button>
								</div>
							</div>
						</td>
					</tr>
				))}
			</tbody>
		</table>
	);
};

export default IncentiveTable;
